import { render, staticRenderFns } from "./LiveTerminalsTable.vue?vue&type=template&id=51f74b52&"
import script from "./LiveTerminalsTable.vue?vue&type=script&lang=js&"
export * from "./LiveTerminalsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports